import PropTypes from 'prop-types'
import React     from 'react'
import { Route } from 'react-router-dom'

import { NavLink } from 'alto-react-components/lib/components'

import { transactionHistorySetting                                   } from './settings'
import { clientManagement, transactionManagement, transactionHistory } from './routes'
import { ClientManagement, TransactionManagement, TransactionHistory } from './components'

export * from './routes'

route = (path, component, options) ->
  <Route key={path} path={path} component={component} {...options} />

export defaultClientRoute = (settings) ->
  setting = transactionHistorySetting(settings)

  setting.enabled and transactionHistory

export defaultAdminRoute = ->
  clientManagement

export adminRoutes = ->
  [
    route(clientManagement,      ClientManagement),
    route(transactionManagement, TransactionManagement)
  ]

export clientRoutes = (settings) ->
  setting = transactionHistorySetting(settings)

  if setting.enabled then [route(transactionHistory, TransactionHistory)] else []

export TransactionHistoryNavLink = ({ children }, { settings }) ->
  setting = transactionHistorySetting(settings)

  if setting.enabled then <NavLink to={transactionHistory}>{children}</NavLink> else null

TransactionHistoryNavLink.contextTypes = { settings: PropTypes.object }
